import Request from './request';
import { RequestProxyType } from './request/index.type';
import { AxiosRequestConfig } from 'axios';
import { AuthStorageProxyType } from './types';

type ConType = new (config: AxiosRequestConfig, authStorage: AuthStorageProxyType) => RequestProxyType;

function createInstance(Con: ConType, authStorage: AuthStorageProxyType): RequestProxyType {
  return new Con(
    {
      baseURL: '/',
    },
    authStorage,
  );
}

function createRequest(authStorage: AuthStorageProxyType): RequestProxyType {
  const request: RequestProxyType = createInstance(Request as unknown as ConType, authStorage);
  return request;
}
export default createRequest;
